<template>
  <card-wrapper class="py-8">
    <pie-chart :is-loading="isLoading"
               :aggregate-request-outcomes="chartData"
               :total="total"
               title="User Feedback"
               :hint="hint"
               :default-chart-data="[]"
               id="user-feedback-chart"
               class="min-w-64"
    />
  </card-wrapper>
</template>

<script>
import PieChart from '@/components/analytics/charts/PieChart'
import CardWrapper from '@/components/base-components/CardWrapper'
import { CHART_TEXT } from '@/utils/text.constants'

export default {
  name: 'UserFeedbackPieChart',

  components: {
    PieChart,
    CardWrapper
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    // { positive, negative, notRated } from GET /analytics/user-feedback, null when not loaded
    feedback: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      hint: CHART_TEXT.USER_FEEDBACK_HINT
    }
  },

  computed: {
    total() {
      const { positive = 0, negative = 0, notRated = 0 } = this.feedback || {}
      return positive + negative + notRated
    },

    // empty array = PieChart's empty state
    chartData() {
      if (!this.feedback) return []

      return [
        { legendType: 'positiveFeedback', count: this.feedback.positive },
        { legendType: 'negativeFeedback', count: this.feedback.negative },
        { legendType: 'notRated', count: this.feedback.notRated }
      ].filter(({ count }) => count > 0)
    }
  }
}
</script>
